<div class="table-responsive">
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col" translate>AGREEMENT_ID</th>
        <th scope="col" translate>SUPPLIER</th>
        <th scope="col" translate>DISCOUNT_PERCENTAGE</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let discount of data">
        <th scope="row">{{discount.agreementId}}</th>
        <td>{{ discount.supplierName }}</td>
        <td>{{ discount.discountPercentage }}</td>
      </tr>
    </tbody>
  </table>
</div>
